module.exports = __webpack_public_path__ + "img/2.b24002dd.png";